import { staticTableCellDecorator } from 'Shared/components';
export const modelColumnMapper = {
    genotypic: 'genotypic / additive',
};
export const modelColumnFormatter = staticTableCellDecorator((value) => (modelColumnMapper[value] ? modelColumnMapper[value] : value));
